import { combineReducers } from '@reduxjs/toolkit';
import BaselineComparisonSlice from '@store/features/filters/BaselineComparisonSlice/BaselineComparisonSlice';
import MainPageSlice from '@store/features/filters/MainPageSlice';
import RigSlice from '@store/features/filters/RigSlice';

const FiltersReducer = combineReducers({
  baselineComparison: BaselineComparisonSlice,
  mainPage: MainPageSlice,
  rigs: RigSlice
});

export const getFiltersSlice = (state) => state.filters;

export default FiltersReducer;
